<template>
  <v-dialog
    v-model="dialog"
    width="640"
    open-on-focus
    no-click-animation
    persistent
    content-class="static-media-picker-dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <v-toolbar flat height="76">
        <v-toolbar-title class="static-media-picker-toolbar-title"
          >Placeholder gallery</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn color="accent" icon tile @click="closeDialog">
          <v-icon size="24">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="static-media-picker-container">
        <v-overlay :value="staticMediaLoading" z-index="4">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-container>
          <v-row>
            <v-col
              class="pa-2"
              v-for="(staticMedia, index) in staticMedia"
              :key="`${index}_${staticMedia.id}`"
              @click="chooseStaticMedia(staticMedia)"
              cols="12"
              sm="4"
            >
              <v-img
                :src="staticMedia.mediaUrl"
                :aspect-ratio="188 / 160"
                @error="refetchStaticMedia"
                class="static-media__file"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="accent lighten-2"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import StaticMediaMixin from '@/mixins/staticMedia'

export default {
  name: 'StaticMediaPickerDialog',
  mixins: [StaticMediaMixin],
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  watch: {
    showDialog: function(val) {
      if (val) {
        this.dialog = true
      } else {
        this.dialog = false
      }
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false
      this.$emit('close-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) this.closeDialog()
    },
    chooseStaticMedia(data) {
      this.$emit('static-media-picked', data)
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.static-media-picker {
  &-container {
    background: $bh-white;
    padding: 0 0.75 * $gutter;
    height: 100%;
    overflow: auto;
  }
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    height: calc(100% - 76px); // 76px is height of v-toolbar in v-dialog header
    max-height: calc(100% - #{2 * $gutter}) !important;
    > .v-card {
      width: 100%;
      height: 100%;
      background-color: $bh-blue--4;
      overflow: auto;
    }
    .static-media__file {
      cursor: pointer;
      border-radius: 16px;
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-size: 1.5715rem;
    font-weight: bold;
  }
}
</style>
